<template>
  <BaseModal
    :value="dialogState"
    :modal-title="$t('utils.assignedCollaborator')"
    is-unique
    @close="reset"
  >
    <template #modal>
      <base-autocomplete
        v-model="form.collaborator"
        :loading="collaboratorFilter.loading"
        :items="collaboratorFilter.items"
        :filter="() => true"
        :search-input.sync="collaboratorFilter.email"
        item-text="email"
        item-value="id"
        solo
        :menu-props="{ offsetY: true }"
        clearable
        @keyup="handleKeyUp()"
        @click:clear="handleKeyUp()"
      >
        <template #append-item>
          <div v-intersect="loadMoreCollaborators()" />
        </template>
      </base-autocomplete>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="reset"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton
        :disabled="isLoading || !form.collaborator"
        type="primary"
        @click="submit"
      >
        {{ $t("utils.validate") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { mapState } from "vuex";
import FolderAPI from "@/modules/Folder/Services/folder.api";
import OrganizationAPI from "@/core/Services/organization.api";

export default {
  name: "FolderAssignCollaboratorDialog",
  data() {
    return {
      form: {
        collaborator: null,
      },
      isLoading: false,
      assignableCollaborators: [],
      oldEmailValue: null,
      collaboratorFilter: {
        loading: false,
        page: 1,
        items: [],
        pageSize: 10,
        email: undefined,
        searchTimeoutRef: undefined,
      },
    };
  },
  computed: {
    ...mapState({
      dialogState: (state) =>
        state.folder.modals.isFolderAssignCollaboratorDialogOpen,
      activeFolder: (state) => state.folder.activeFolder,
    }),
  },
  watch: {
    dialogState(newVal) {
      if (newVal) {
        this.initialize();
      }
    },
  },
  methods: {
    reset() {
      this.$store.commit("folder/SET_MODAL_ASSIGN_COLLABORATOR_STATUS", false);
    },
    async initialize() {
      this.isLoading = true;
      if (!this.activeFolder) return;
      if (this.activeFolder.assign?.id) {
        this.collaboratorFilter.items.push(this.activeFolder.assign);
        this.form.collaborator = this.activeFolder.assign?.id;
      } else {
        this.form.collaborator = null;
      }
      await this.fetchCollaborators(true);
      this.isLoading = false;
    },
    // collaborator
    async fetchCollaborators(loadMore = false) {
      if (this.collaboratorFilter.loading && !this.collaboratorFilter.page)
        return;
      this.collaboratorFilter.loading = true;
      const res = await OrganizationAPI.getOrganizationCollaborators(
        this.$route.params.organizationId,
        this.collaboratorFilter.page,
        this.collaboratorFilter.email
      );
      this.collaboratorFilter = {
        ...this.collaboratorFilter,
        items: loadMore
          ? [
              ...this.collaboratorFilter.items,
              ...res.data.results.map((c) => c.user),
            ]
          : res.data.results.map((c) => c.user),
        next: res.data.next,
      };
      this.collaboratorFilter.loading = false;
    },
    filterCollaborators() {
      this.collaboratorFilter.page = 1;
      if (this.collaboratorFilter.searchTimeoutRef)
        clearTimeout(this.collaboratorFilter.searchTimeoutRef);
      this.collaboratorFilter.searchTimeoutRef = setTimeout(async () => {
        this.fetchCollaborators();
      }, 400);
    },
    async loadMoreCollaborators(_, __, isIntersecting) {
      if (
        !isIntersecting ||
        this.collaboratorFilter.loading ||
        !this.collaboratorFilter.next
      )
        return;
      this.collaboratorFilter.page = this.collaboratorFilter.next;
      this.collaboratorFilter.loading = true;
      try {
        const res = await OrganizationAPI.getOrganizationCollaborators(
          this.$route.params.organizationId,
          this.collaboratorFilter.page,
          this.collaboratorFilter.email
        );
        this.collaboratorFilter = {
          items: [...this.collaboratorFilter.items, ...res.data.results],
          next: res.data.next,
        };
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.questionsFilesFilter.loading = false;
    },
    async submit() {
      if (!this.form.collaborator) return;
      let payload = { collaborator: this.form.collaborator };
      try {
        await FolderAPI.postAssingCollaborator({
          organizationId: this.$route.params.organizationId,
          folderId: this.$route.params.folderId,
          payload,
        });

        this.$store.commit("folder/SET_ACTIVE_FOLDER", {
          ...this.activeFolder,
          assign: payload.collaborator
            ? this.collaboratorFilter.items.find(
                (c) => c.id == payload.collaborator
              )
            : null,
        });
        const successMessage = this.$t(
          payload.assign
            ? "folder.assignCollaboratorForm.successAdd"
            : "folder.assignCollaboratorForm.successRemove"
        );
        this.$store.dispatch("snackbar/active", {
          message: successMessage,
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("folder.assignCollaboratorForm.error"),
          type: "ERROR",
        });
      }
      this.reset();
    },
    handleKeyUp() {
      if (this.oldEmailValue === this.collaboratorFilter.email) return;
      this.oldEmailValue = this.collaboratorFilter.email;
      this.filterCollaborators();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 8px;
}
.modal_content {
  & > * {
    margin-top: 24px !important;
  }
}
.modal_actions {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & > * {
    margin-left: 16px;
  }
}
</style>
